import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "app-section" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center gap-2 app-section-title"
}
const _hoisted_3 = { class: "text-header m-0" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSection',
  props: {
    title: { default: "" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (__props.title || _ctx.$slots.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "icon"),
          _createElementVNode("p", _hoisted_3, _toDisplayString(__props.title), 1)
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})